import { Membership } from '@towns-protocol/sdk';
export function toStreamView(stream, membership) {
    const metadata = stream.view.getMemberMetadata();
    const members = Array.from(stream.view.getMembers().joined.values()).map((streamMember) => {
        const info = metadata.userInfo(streamMember.userId);
        return {
            userId: streamMember.userId,
            membership: Membership.Join,
            username: info?.username ?? '',
            usernameConfirmed: info?.usernameConfirmed ?? false,
            usernameEncrypted: info?.usernameEncrypted ?? false,
            displayName: info?.displayName ?? '',
            displayNameEncrypted: info?.displayNameEncrypted ?? false,
            disambiguate: false,
        };
    });
    return {
        id: stream.streamId,
        membership: membership,
        members: members,
    };
}
//# sourceMappingURL=CasablancaUtils.js.map